import { __read } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes, FaWindowMaximize, FaWindowRestore } from 'react-icons/fa';
export var Overlay = function (props) {
    var _a;
    var isShowing = props.isShowing, hide = props.hide, children = props.children, hideHeader = props.hideHeader, _b = props.frameInset, frameInset = _b === void 0 ? 0 : _b, _c = props.frameInsetCss, frameInsetCss = _c === void 0 ? false : _c, _d = props.takeOverClassName, takeOverClassName = _d === void 0 ? '' : _d, _e = props.isMaximized, isMaximized = _e === void 0 ? false : _e, onToggleMaximize = props.onToggleMaximize;
    var node = React.useRef(null);
    var framed = frameInset > 0;
    var showWindowControls = typeof onToggleMaximize === 'function';
    var _f = __read(React.useState(false), 2), enterReady = _f[0], setEnterReady = _f[1];
    React.useEffect(function () {
        if (!isShowing) {
            setEnterReady(false);
            return;
        }
        setEnterReady(false);
        var id = requestAnimationFrame(function () {
            requestAnimationFrame(function () { return setEnterReady(true); });
        });
        return function () { return cancelAnimationFrame(id); };
    }, [isShowing]);
    React.useEffect(function () {
        // add when mounted
        document.addEventListener('keydown', onKeyPressed);
        document.addEventListener("mousedown", handleClickOutside);
        // return function to be called when unmounted
        return function () {
            document.removeEventListener('keydown', onKeyPressed);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    var handleClickOutside = function (e) {
        if (node && node.current && node.current.contains(e.target)) {
            return;
        }
        var target = e.target;
        if (target && target.closest && target.closest('.order-activity-messenger')) {
            return;
        }
        if (node && node.current && e.target.classList.contains('ignore-clickoutside')) {
            return;
        }
        if (e.target.classList && e.target.classList.contains('take-over-backdrop')) {
            return;
        }
        // outside click
        if (props.isShowing) {
            props.hide && props.hide();
        }
    };
    var onKeyPressed = function (e) {
        if (e.key === 'Escape' && props.hide && props.isShowing) {
            e.preventDefault();
            props.hide();
        }
    };
    var stopChromeEvent = function (e) {
        e.stopPropagation();
    };
    var level = props.level || 1;
    var framedStyle = framed && !frameInsetCss
        ? (_a = {}, _a['--take-over-inset'] = "".concat(frameInset, "px"), _a)
        : undefined;
    var takeOverExtraClass = takeOverClassName ? ' ' + takeOverClassName : '';
    var showingClass = isShowing && enterReady ? ' is-showing' : '';
    var renderCloseControl = function () {
        if (showWindowControls) {
            return (React.createElement("div", { className: "take-over__chrome" },
                React.createElement("button", { type: "button", className: "take-over__chrome-btn take-over__chrome-btn--size", onClick: onToggleMaximize, onMouseDown: stopChromeEvent, "aria-label": isMaximized ? 'Restore original size' : 'Maximize' }, isMaximized ? React.createElement(FaWindowRestore, null) : React.createElement(FaWindowMaximize, null)),
                React.createElement("button", { type: "button", className: "take-over__chrome-btn take-over__chrome-btn--close", onClick: hide, onMouseDown: stopChromeEvent, "aria-label": "Close" },
                    React.createElement(FaTimes, null))));
        }
        return (React.createElement("div", { onClick: hide, className: "take-over__close" },
            React.createElement(FaTimes, null)));
    };
    return ReactDOM.createPortal(React.createElement(React.Fragment, null,
        framed && (React.createElement("div", { className: 'take-over-backdrop' +
                showingClass +
                (isMaximized ? ' take-over-backdrop--maximized' : ''), onClick: hide, "aria-hidden": "true" })),
        React.createElement("div", { className: 'take-over' +
                showingClass +
                (hideHeader ? ' hide-header' : '') +
                (framed ? ' take-over--framed' : '') +
                takeOverExtraClass +
                ' level-' +
                level, style: framedStyle, ref: node },
            renderCloseControl(),
            React.createElement(React.Fragment, null, children && children))), document.getElementById('root'));
};
//# sourceMappingURL=Overlay.js.map